import { render, staticRenderFns } from "./MaterialDistributionDetails.vue?vue&type=template&id=8f0f2e92&scoped=true"
import script from "./MaterialDistributionDetails.vue?vue&type=script&lang=js"
export * from "./MaterialDistributionDetails.vue?vue&type=script&lang=js"
import style0 from "./MaterialDistributionDetails.vue?vue&type=style&index=0&id=8f0f2e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0f2e92",
  null
  
)

export default component.exports